/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module isTruthy
 */

import _Boolean from './.internal/_Boolean';

export default function isTruthy(value) {
  return _Boolean(value);
}
